<template>
  <el-dialog
    width="1000px"
    :center="true"
    :show-close="true"
    :visible.sync="visiable"
    :close-on-click-modal="false"
    append-to-body
    top="1vh"
  >
    <div slot="title">
      <div style="font-size: 16px">新增项目</div>
    </div>
    <div style="display: flex; justify-content: space-between">
      <el-form
        :model="param"
        :inline="true"
        size="mini"
        style="display: flex; align-items: center"
      >
        <el-form-item label="选择项目">
          <el-select
            clearable
            v-model="param.prjCode"
            filterable
            :filterMethod="(val)=>{$store.state.funciton.filter(val, this, 'allCustomers', 'keep')}"
            @visible-change="()=>{$store.state.funciton.filter('', this, 'allCustomers', 'keep')}"
            placeholder="请选择..."
          >
            <el-option
              :label="item[1]"
              :value="item[0]"
              v-for="item in allCustomers"
              :key="item[0]"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" @click="submitForm()" size="mini"
          >查询</el-button
        >
      </el-form>
    </div>
    <div style="color: #ff9999; margin-bottom: 14px">
      <i class="el-icon-warning"></i>
      请先选择一个项目，系统会将选择的项目所属的所有月份的项目一起查询出来
    </div>
    <div class="tableBody">
      <el-table
        v-loading="listLoading"
        class="limitManagerTable table-expand"
        style="width: 100%"
        :data="tableData"
        size="mini"
        border
        header-row-class-name="table-header"
        @selection-change="handleSelectionChange"
      >
        >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column
          minWidth="200"
          prop="[0]"
          label="项目编号"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="[1]"
          minWidth="200"
          label="项目名称"
          align="center"
        ></el-table-column>
        <el-table-column
          width="140"
          prop="[2]"
          label="项目开始日期"
          align="center"
        ></el-table-column>
        <el-table-column
          width="140"
          prop="[3]"
          label="项目结束日期"
          align="center"
        ></el-table-column>
      </el-table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visiable = false" size="small">取 消</el-button>
      <el-button
        @click="subAdd()"
        type="primary"
        :disabled="multipleSelection.length === 0"
        size="small"
        >确认添加</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import utils from "@/common/js/util.js";
export default {
  data() {
    return {
      allCustomers: [], //项目列表数组 用于筛选
      keep: [], //项目列表数组 全部用于还原
      multipleSelection: [], //选中项
      //筛选项参数
      param: {},
      //表单翻页
      formData: {
        total: null,
      },
      tableData: [], //表单信息
      listLoading: false,
      item: {},
      visiable: false,
    };
  },
  methods: {
    show(item) {
      // console.log(item);
      this.getAllCustomer(item[0]);
      this.param = {};
      this.tableData = [];
      this.formData = {
        total: null,
      };
      this.multipleSelection = [];
      this.item = item;
      this.visiable = true;
    },
    //工具类，错误提示框
    myNotify(_this, type, normal, or) {
      utils.myNotify(_this, type, normal, or);
    },
    //获取项目列表
    getAllCustomer(customerMappingId) {
      this.$http({
        method: "GET",
        url: "/rest/LongPromotionContractProject/projectDropDownList",
        params: {
          customerMappingId: customerMappingId,
        },
      })
        .then((res) => {
          this.allCustomers = res.data.items;
          this.keep = res.data.items;
        })
        .catch((err) => {
          this.myNotify(this, "error", err.response, "查询失败，请稍后重试");
        });
    },
    //提交表单（筛选功能）
    submitForm() {
      //先判断是否选中了项目
      if (!this.param.prjCode) {
        this.myNotify(this, "warning", "请先选择一个项目");
      } else {
        this.getData();
      }
    },
    //获取数据
    getData() {
      this.listLoading = true;
      this.multipleSelection = [];
      let params = {
        prjCode: this.param.prjCode,
        customerMappingId: this.item[0],
      };
      //获取表单数据
      this.$http({
        method: "POST",
        headers: { "content-type": "application/json" },
        url: "/rest/LongPromotionContractProject/customerPrjList",
        params: params,
      })
        .then((res) => {
          this.tableData = res.data.items;
          this.formData.total = res.data.totalItemsCount;
          this.listLoading = false;
        })
        .catch((err) => {
          this.listLoading = false;
          this.myNotify(this, "error", err.response, "查询失败，请稍后重试");
        });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    checkAdd() {
      return new Promise((resolve, reject) => {
        this.$http({
          method: "POST",
          headers: { "content-type": "application/json" },
          url: "/rest/LongPromotionContractProject/countCusMapIdAndQhrCusName",
          // data: this.multipleSelection.map((el) => el[0]),
          data: [
            {
              customerMappingId: this.item[0],
              projectCode: this.param.prjCode,
            },
          ],
        }).then((res) => {
          if (res.data.status && res.data.status != 200) {
            this.myNotify(this, "error", res.data.message);
            return;
          }
          if (res.data.items.length != 0) {
            // 此处需要遍历
            let textList = res.data.items.map((el, index) => {
              return `<div>${index + 1}、项目<span style="color:#ff4d4f"> ${
                el[1]
              } </span>与合同客户<span style="color:#ff4d4f"> ${
                el[0]
              } </span>已关联</div>`;
            });
            let text = textList.join("");
            this.$confirm(
              `
        <div style="max-height:300px;overflow:auto">${text}
        是否继续将选中的项目关联到<span style="color:#ff4d4f"> ${this.item[1]} </span>？</div>`,
              "提示",
              {
                distinguishCancelAndClose: true,
                dangerouslyUseHTMLString: true,
                appendToBody: true,
                confirmButtonText: "确认",
                cancelButtonText: "取消",
              }
            ).then(() => {
              resolve(true);
            });
          } else {
            resolve(true);
          }
        });
      });
    },
    //确认添加
    async subAdd() {
      //先查询 选中的项目有所属其他月份的项目与其他合同客户是否关联
      let res = await this.checkAdd(this.multipleSelection);
      if (res) {
        this.tosubAdd();
      }
    },
    tosubAdd() {
      this.$http({
        method: "POST",
        url: "/rest/LongPromotionContractProject/insertCRMConPrj",
        headers: { "content-type": "application/json" },
        data: this.multipleSelection.map((el) => {
          return {
            customerMappingId: this.item[0],
            projectCode: el[0],
          };
        }),
        params: {
          operatorId: sessionStorage.getItem("sysUserId"),
        },
      })
        .then((res) => {
          if (res.data.status && res.data.status != 200) {
            this.myNotify(this, "error", res.data.message);
            return;
          }
          this.$emit("done");
          // this.visiable = false;
          this.tableData = [];
          this.param = {};
          this.myNotify(this, "success", "添加成功");
        })
        .catch(() => {
          this.myNotify(this, "error", "请求失败，请稍后重试");
        });
    },
  },
};
</script>
  <style lang="scss" scoped>
.tableBody {
  min-height: 425px;
}
.el-form-item--mini.el-form-item {
  margin-bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/views/personnelCenter/customerProject/Add.vue